module.exports = __webpack_public_path__ + "images/5708a1a14a2e9244b3d8d8c97709daa8.png";